import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { AppView } from "../../utils/appView";
import { useAppView } from "../../contexts/appView.context";

export const ViewSwitcher: React.FC = () => {
    const { activeView, canSwitch, setActiveView } = useAppView();

    if (!canSwitch) {
        return null;
    }

    return (
        <ToggleButtonGroup
            exclusive
            size="small"
            color="primary"
            value={activeView}
            onChange={(_event, next: AppView | null) => {
                if (next) {
                    setActiveView(next);
                }
            }}
            aria-label="App view"
            data-testid="view-switcher"
            sx={(theme) => ({
                backgroundColor: alpha(theme.palette.common.white, 0.08),
                "& .MuiToggleButton-root": {
                    color: "common.white",
                    borderColor: alpha(theme.palette.common.white, 0.4),
                    textTransform: "none",
                },
                "& .Mui-selected": {
                    color: "common.white",
                    backgroundColor: "primary.main",
                },
            })}
        >
            <ToggleButton value="practitioner" data-testid="view-switcher-practitioner">
                Practitioner
            </ToggleButton>
            <ToggleButton value="manager" data-testid="view-switcher-manager">
                Manager
            </ToggleButton>
        </ToggleButtonGroup>
    );
};
